import styled, { css } from "styled-components";

import DefaultMenuList from "@material-ui/core/MenuList";
import { Popper as DefaultPopper } from "@material-ui/core";

import { COLORS } from "constants/colorScheme";

export const Popper = styled(DefaultPopper)`
  && {
    ${({ disablePortal }) =>
      disablePortal &&
      css`
        z-index: 5;
      `};
  }
`;

export const MenuList = styled(DefaultMenuList)`
  && {
    padding: 4px 0;

    border-radius: 8px;
  }

  && .MuiListItem-root {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: 0px;
    padding: 8px 16px;

    border-radius: 0px;
    color: ${COLORS.BLACK};

    &:hover {
      color: ${COLORS.CYAN};
      background-color: ${COLORS.CYAN_LIGHT_20};
    }
  }

  && .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: ${COLORS.WHITE};
    color: ${COLORS.CYAN};
    border-bottom: 2px solid ${COLORS.CYAN};
  }

  && .MuiListItemText-root {
    display: flex;
    align-items: center;
  }
`;

export const IconContainer = styled.div`
  margin-left: 8px;
`;

export const CheckedIcon = styled.div`
  display: flex;

  & path,
  & use {
    fill: ${COLORS.CYAN};
  }
`;

export const IconGap = styled.div`
  width: 24px;
  height: 24px;
`;
